import React, { Component } from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';


class RegularSearchIncompanyKennis extends Component {

    render() {
        return (
            <div>
                {/* TODO: Create regular search on instituut and name. in all courses en knowledge, and filter this per type of page. */}
                <Form horizontal className="regularSearch">
                    <FormGroup controlId="regularSearchBoxInstituut">
                        <Col componentClass={ControlLabel} sm={4}>
                            Naam bedrijf
                            </Col>
                        <Col sm={4}>
                            <FormControl type="text" name="regularSearchInstituut" />
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="regularSearchBoxCursus">
                        <Col componentClass={ControlLabel} sm={4}>
                            Naam bijeenkomst
                            </Col>
                        <Col sm={4}>
                            <FormControl type="text" name="regularSearchInstituut" />
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        )
    };

}

export default RegularSearchIncompanyKennis;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Kennis/Toevoegen/RegularSearchIncompanyKennis.js